import i18n from 'utils/i18n';

const { t } = i18n.i18n;

const commonConfig = {
  colors: {
    border: '#D9D9D9',
    bg: '#00000005',
    text: '#333333',
  },
};

export const paymentStatusMap = {
  unpaid: {
    label: t('collectionInvoices.paymentStatus.unpaid'),
    ...commonConfig,
  },
  sent: {
    label: t('collectionInvoices.paymentStatus.unpaid'),
    ...commonConfig,
  },
  holdingCash: {
    label: t('collectionInvoices.paymentStatus.holdingCash'),
    ...commonConfig,
  },
  paid: {
    label: t('collectionInvoices.paymentStatus.paid'),
    colors: {
      border: '#B7EB8F',
      bg: '#F6FFED',
      text: '#52C41A',
    },
  },
  partially_paid: {
    label: t('collectionInvoices.paymentStatus.partial'),
    colors: {
      border: '#FFD591',
      bg: '#FFF7E6',
      text: '#FF9900',
    },
  },
  overdue: {
    label: t('collectionInvoices.paymentStatus.overdue'),
    colors: {
      border: '#FFA39E',
      bg: '#FFF1F0',
      text: '#F5222D',
    },
  },
};
